var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRussian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "182px",
    viewBox: "0 0 182 182",
    width: "182px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Russia",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.878829,120 C162.523738,154.955772 129.186567,180 90,180 C50.8134331,180 17.4762623,154.955772 5.12117078,120 L174.878833,120 Z M174.878829,120",
    fill: "#CA4738",
    id: "Oval-1-copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.878829,120.000001 C178.195374,110.616633 180,100.519063 180,90 C180,79.480937 178.195374,69.3833673 174.878829,59.9999996 L5.12116698,60 C1.80462645,69.3833673 0,79.480937 0,90 C0,100.519063 1.80462645,110.616633 5.12117078,120 L174.878833,120 Z M174.878829,120.000001",
    fill: "#346DA6",
    id: "Oval-1-copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.878829,59.9999996 C162.523738,25.0442275 129.186567,0 90,0 C50.8134331,0 17.4762623,25.0442275 5.12117078,59.9999996 L174.878833,60 Z M174.878829,59.9999996",
    fill: "#FFFFFF",
    id: "Oval-1-copy-5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussian);
export default __webpack_public_path__ + "static/media/russian.9ac3094de447390d126ef26bc8efd246.svg";
export { ForwardRef as ReactComponent };